import React from 'react';
import styled, { css } from 'styled-components';


const baseStyle = css`
    color: black;
    font-weight: 300;
    margin-top: 0;
    margin-bottom: ${({ noMargin }) => (noMargin ? '0px' : '20px' )};
`
const Heading1 = styled.h1`
    font-size: 30px;
    line-height: 40px;
    font-family: 'Poppins', sans-serif;
    ${baseStyle};
    font-weight: 500;
`

const Heading2 = styled.h2`
    font-size: 25px;
    line-height: 33px;
    font-family: 'Poppins', sans-serif;
    ${baseStyle};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
`

const Heading3 = styled.h3`
    font-size: 16px;
    line-height: 21px;
    font-family: 'Poppins', sans-serif; 
    ${baseStyle}
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '0px')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
    color: ${({ color }) => (color ? color : '#000000')};
`

const Heading4 = styled.h4`
    font-size: 14px;
    line-height: 18px;
    font-family: 'Poppins', sans-serif; 
    ${baseStyle}
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
    color: ${({ color }) => (color ? color : '#000000')};
`

const P = styled.p`
    ${baseStyle}
    display: ${({ noShow }) => (noShow ? 'none' : 'inline')};
    font-size: ${({ error }) => (error ? '12px' : '14px')};
    line-height: 22px;
    text-align: ${({ centerAlign, rightAlign }) => {
        if (centerAlign) return 'center';
        if (rightAlign) return 'right';
        else return 'left';
    }};
    font-family: 'Poppins', sans-serif;
    ${({ error }) => (error ? "'Segoe UI', sans-serif" : "'Poppins', sans-serif")};
    color: ${({ error, success }) => {
        if (error) return 'red';
        if (success) return 'green';
        else return 'black';
    }};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
`

const Heading = ({ children, color, noMargin, size, centerAlign, rightAlign, marginTop, marginLeft, marginBottom, error, noShow} ) => {
    if (size === 'h1') return <Heading1 noMargin={noMargin} color={color}>
                            {children}</Heading1>;

    if (size === 'h2') return <Heading2 
        noMargin={noMargin} 
        color={color} 
        marginTop={marginTop}
        marginLeft={marginLeft}
        >
        {children}</Heading2>;

    if (size === 'h3') return <Heading3 
        noMargin={noMargin} 
        color={color} 
        marginTop={marginTop}
        marginLeft={marginLeft}
        marginBottom={marginBottom}
        >
        {children}
        </Heading3>;

    if (size === 'h4') return <Heading4
        noMargin={noMargin}
        color={color}
        marginTop={marginTop}
        marginLeft={marginLeft}
        >
        {children}</Heading4>;

    if (size === 'p') return <P 
        noMargin={noMargin} 
        color={color}
        error={error}
        noShow={noShow}
        centerAlign={centerAlign}
        rightAlign={rightAlign}
        marginTop={marginTop}
        marginLeft={marginLeft}
        >
        {children}
        </P>;
}


export default Heading;